/**
 * popup-scrollable.js
 *
 * Generic modal open/close helpers using:
 * - [data-modal-target] to open
 * - [data-close-button] to close
 * - #overlay click to close all active modals
 *
 * Contract:
 * - Script may be bundled globally.
 * - Must silently no-op if required DOM (overlay) is not present.
 * - Must not throw if used on a page without #overlay.
 */

(function bootPopupScrollable() {
  // Idempotency guard
  if (window.__popupScrollableInitialized) return;
  window.__popupScrollableInitialized = true;

  const overlay = document.getElementById('overlay');
  if (!overlay) {
    // No overlay means this modal system is not active on this page.
    // Silently no-op to support shared bundles.
    return;
  }

  const openModalButtons = document.querySelectorAll('[data-modal-target]');
  const closeModalButtons = document.querySelectorAll('[data-close-button]');

  openModalButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const selector = button.dataset.modalTarget;
      if (!selector) return;

      const modal = document.querySelector(selector);
      openModal(modal, overlay);
    });
  });

  overlay.addEventListener('click', () => {
    const modals = document.querySelectorAll('.modal.active');
    modals.forEach((modal) => closeModal(modal, overlay));
  });

  closeModalButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest('.modal');
      closeModal(modal, overlay);
    });
  });

  function openModal(modal, overlayEl) {
    if (!modal) return;
    modal.classList.add('active');
    overlayEl.classList.add('active');
  }

  function closeModal(modal, overlayEl) {
    if (!modal) return;
    modal.classList.remove('active');
    overlayEl.classList.remove('active');
  }
})();
